import { PanelLeft } from "lucide-react"
import { Button } from "@/components/ui/primitives"
import { SidebarTooltip } from "@/components/ui/sidebar-tooltip"
import { SIDEBAR_TOGGLE_SHORTCUT } from "@/hooks/use-sidebar-toggle-shortcut"
import { useTranslation } from "@/hooks/use-translation"

export function SidebarToggleButton({ collapsed, onToggle }: { collapsed: boolean; onToggle: () => void }) {
  const { t } = useTranslation("layout")
  const label = collapsed ? t("shell.sidebar.expandMenu") : t("shell.sidebar.collapseMenu")

  return (
    <div className="hidden shrink-0 md:flex">
      <SidebarTooltip label={label} shortcut={SIDEBAR_TOGGLE_SHORTCUT} side="bottom">
        <Button
          variant="ghost"
          size="icon"
          type="button"
          className="h-7 w-7 text-ui-text-secondary"
          onClick={onToggle}
          aria-label={label}
          aria-controls="app-sidebar"
          aria-expanded={!collapsed}
        >
          <PanelLeft className="h-3.5 w-3.5" />
        </Button>
      </SidebarTooltip>
    </div>
  )
}
